var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.55 36.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36,14.25,22.57,2.69C20,.54,18.9.39,16.36,2.52L2.55,14.25C0,16.38.65,18.13,4,18.13H5.52v13.3A3.61,3.61,0,0,0,9.14,35h4.52V27.13a5.62,5.62,0,0,1,11.23,0V35h4.52A3.61,3.61,0,0,0,33,31.43V18.13h1.55C37.89,18.13,38.53,16.38,36,14.25Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.3401ae7102ebf79928ca2863b7972bca.svg";
export { ForwardRef as ReactComponent };